import dayjs from 'dayjs';
import { DynamicIcon, FormLabel, PartnerTimeZoneTooltip, SelectTrigger } from 'src/components';
import { SidePanelRow } from 'src/components/SidePanelRow';
import { DISPLAY_DATE_FORMAT } from 'src/constants/date';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { useConversationEntity } from './conversation-entity-context';

export const CreatedRow = (_props: SidePanelRowProps) => {
  const { conversation } = useConversationEntity();

  return (
    <SidePanelRow>
      <FormLabel label="Created" />
      <PartnerTimeZoneTooltip
        tooltipProps={{ placement: 'left' }}
        date={conversation.createdAt}
        partnerId={conversation.partnerId}
      >
        <SelectTrigger
          readOnly
          variant="inline"
          label={dayjs(conversation.createdAt).format(DISPLAY_DATE_FORMAT)}
          icon={<DynamicIcon name="calendar" library="lucide" />}
          aria-label={`Created: ${dayjs(conversation.createdAt).format(DISPLAY_DATE_FORMAT)}`}
          sx={{ width: '100%' }}
        />
      </PartnerTimeZoneTooltip>
    </SidePanelRow>
  );
};
